'use client';

/**
 * CanvasPickerHost — enkraten globalni gostitelj dialoga »Dodaj v canvas«
 * (seja 311). Vpet v korenski layout; zahteve prihajajo iz hover kartic in
 * drugih kratkoživih površin prek canvas-picker-store (glej komentar tam).
 */

import { CanvasPickerDialog } from './CanvasPickerDialog';
import { useCanvasPickerStore } from '@/lib/stores/canvas-picker-store';

export function CanvasPickerHost() {
  const request = useCanvasPickerStore((s) => s.request);
  const closePicker = useCanvasPickerStore((s) => s.closePicker);

  if (!request) return null;
  return (
    <CanvasPickerDialog
      open
      onOpenChange={(open) => !open && closePicker()}
      fragmentHtml={request.html}
      sourceType="manual"
      sourceLabel={request.sourceLabel}
    />
  );
}
